import { Card } from 'aem-libs-react-components/src/components/common/card'
import { useDynamicParams } from 'aem-libs-react-ts/src/hooks/useDynamicParams'

import type { MembershipParams } from '../types'
import { testIds } from '../e2e/testIds'
import { Cards } from './App.styled'


export const RegionNotAllowed = () => {
  const { notAllowedContent } = useDynamicParams<MembershipParams>()

  return (
    <Cards>
      <div />
      <Card textAlign={'left'}>
        <div data-testid={testIds.notAllowedContent} dangerouslySetInnerHTML={{ __html: notAllowedContent }} />
      </Card>
      <div />
    </Cards>
  )
}
